var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{ref:"textarea",staticClass:"table-input textarea-overlay",class:{ collapsed: !_vm.opened },on:{"focus":_vm.focusIn,"blur":_vm.focusOut}})}
var staticRenderFns = []

export { render, staticRenderFns }